import React from "react";
import { motion } from 'framer-motion';

// TODO: Implement email input

/**
 * Form that is shown when an unsupport building type is chosen
 * This form allows the user to leave their email to register their interest
 * */
const BuildingTypeForm = () => {
  return (
    <motion.div 
      initial={{ opacity:0, y:-50 }}
      animate={{ opacity:1, y:0 }}
      exit={{ opacity:0, y:-50 }}
      transition={{ duration: 0.5 }}
      style={style}
    >
      Sorry we don't support your type - leave your email so we can notify you
    </motion.div>
  );
};

const style = {
  width: '200px',
  display: 'block',
  backgroundColor: 'Blue'
}

export default BuildingTypeForm;